export const ICON_SIZE_DEFAULT = 32;
export const COPIED_TIMEOUT = 1000;

// cdn url
export const CDN_URL = 'https://cdn-assets.evacenter.com';
